import { FileText, Landmark, TrendingUp, Receipt } from "lucide-react";

import { formatMoneyCompact, formatNumber } from "@/lib/format";
import { Skeleton } from "@/components/ui/skeleton";
import type { TdmStats } from "@/types/tdm";

function Kpi({
  icon,
  label,
  value,
  sub,
  color,
}: {
  icon: React.ReactNode;
  label: string;
  value: string;
  sub?: string;
  color: string;
}) {
  return (
    <div className="flex flex-col gap-2 rounded-2xl bg-card p-5 shadow-sm">
      <div className="flex items-center gap-2">
        <span
          className="flex size-8 items-center justify-center rounded-lg"
          style={{ backgroundColor: `${color}1a`, color }}
        >
          {icon}
        </span>
        <span className="text-xs font-bold uppercase tracking-wide text-muted-foreground">
          {label}
        </span>
      </div>
      <p className="text-2xl font-extrabold tracking-tight">{value}</p>
      {sub && <p className="text-xs text-muted-foreground">{sub}</p>}
    </div>
  );
}

export function TdmKpis({
  data,
  isLoading,
}: {
  data?: TdmStats;
  isLoading?: boolean;
}) {
  if (isLoading && !data) {
    return (
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className="h-28 rounded-2xl" />
        ))}
      </div>
    );
  }
  const k = data?.kpis;
  const ticket =
    k && k.licitaciones > 0 ? k.potencialVentaSoles / k.licitaciones : 0;
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <Kpi
        icon={<FileText className="size-4" />}
        label="Licitaciones"
        value={formatNumber(k?.licitaciones ?? 0)}
        sub={`${formatNumber(k?.recursos ?? 0)} recursos de asfalto`}
        color="#2563eb"
      />
      <Kpi
        icon={<Landmark className="size-4" />}
        label="Total de inversión"
        value={formatMoneyCompact(k?.inversionSoles ?? 0)}
        sub="Presupuesto de las obras"
        color="#8b5cf6"
      />
      <Kpi
        icon={<TrendingUp className="size-4" />}
        label="Potencial de venta"
        value={formatMoneyCompact(k?.potencialVentaSoles ?? 0)}
        sub="Suma del match de asfalto"
        color="#10b981"
      />
      <Kpi
        icon={<Receipt className="size-4" />}
        label="Ticket promedio"
        value={formatMoneyCompact(ticket)}
        sub="Potencial de venta por licitación"
        color="#f59e0b"
      />
    </div>
  );
}
